import { FaxListItemStyle } from '~/pages/Fax/componentStyles/FaxListItem.style'

export const faxComponentStyles = {
  components: {
    FaxListItemStyle,
  },
}
